<div class="topdiv" >



  <div class="row topRowMargins headerStyle" style="margin-top: 0;">
    <div  style="margin-left: 15px;">
      <label class="textColour">Create Product Group</label>
    </div>
  </div>
  <div class="container" style="margin: 0;padding: 0;" >
     <form [formGroup]="Formvalid" novalidate>
        <div class="row">
            <div class="col-lg-9">
                <mat-form-field appearance="outline">
                  <mat-label i18n="@@TMclassifiedserviceType">Product Group Name</mat-label>
                  <input matInput type="text" formControlName="productGroupNameControler"  [(ngModel)]="productGroupName"  required>
                    <mat-error *ngFor="let validation of validation_messages.productGroupNameControler">
                      <span
                        *ngIf="Formvalid.get('productGroupNameControler').hasError(validation.type) && (Formvalid.get('productGroupNameControler').dirty || Formvalid.get('productGroupNameControler').touched)">
                        {{ validation.message }}
                      </span>
                    </mat-error>
                </mat-form-field>
              </div>
              </div>
              </form>
              <div style="display: flex;margin-top: 6%;">
                  <span class="example-spacer"></span>
       <app-common-button
          label="Cancel"
          title="Cancel"
          [buttonId]="1111"
           [variant]="'cancel'"
          width="150px"
          [critical]="true"
           (clicked)="onCancel()"
           style="margin-left: 6px;margin-right:6px;"
          >
 
          </app-common-button>
       <app-common-button
          [label]="buttonName"
          [title]="buttonName"
          [buttonId]="1111"
          width="150px"
          [critical]="true"
           style="margin-left: 6px;margin-right:6px;"
           (clicked)="onSaveClick()"
          >
 
          </app-common-button>
              </div>
  </div>
  </div>